import { render, staticRenderFns } from "./VersionLocalizationSettings.vue?vue&type=template&id=55048b89&lang=pug"
import script from "./VersionLocalizationSettings.vue?vue&type=script&lang=js"
export * from "./VersionLocalizationSettings.vue?vue&type=script&lang=js"
import style0 from "./VersionLocalizationSettings.vue?vue&type=style&index=0&id=55048b89&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports